export const START_PAGE_MODE = 'START_PAGE_MODE';
export const FINISH_PAGE_MODE = 'FINISH_PAGE_MODE';
export const CHANGE_MODE = 'CHANGE_MODE';
export const START_STUDENT_MODE = 'START_STUDENT_MODE';
export const FINISH_STUDENT_MODE = 'FINISH_STUDENT_MODE';
export const START_COMMENT_MODE = 'START_COMMENT_MODE';
export const FINISH_COMMENT_MODE = 'FINISH_COMMENT_MODE';
export const START_STUDENT_PROGRESS_MODE = 'START_STUDENT_PROGRESS_MODE';
export const FINISH_STUDENT_PROGRESS_MODE = 'FINISH_STUDENT_PROGRESS_MODE';
export const FINISH_COUNTRY_MODE = 'FINISH_COUNTRY_MODE';
export const SET_COUNTRY_TOOLTIP = 'SET_COUNTRY_TOOLTIP';
